import {fraction} from '../utils';

//convert a decimal into a fraction

export function decimalFractionToNormal(num: number): string {
	return fraction(num);
}
